export default __webpack_public_path__ + "static/media/pokebola.af86ac59.png";